import './UsersIndividualsPage.scss';

import React from 'react';
import { connect } from 'react-redux';
import { routerActions } from 'react-router-redux';
import classNames from 'classnames';
import update from 'immutability-helper';
import ReduxInfiniteScroll from 'redux-infinite-scroll';

import { closeConfirmModal, closeModal, openConfirmModal, openModal } from 'containers/App/store/actions';
import { setAssignment } from 'containers/AssignmentsPage/store/actions';
import { emptyAssignment } from 'containers/AssignmentsPage/store/reducers';
import { emptyGroups, getGroups } from '../store/groups/actions';
import { clearUser, deleteUser, emptyUsers, getAssignmentsAndSetUser, getUsers, postPutUser, postUserAvatar, setUser, updateSearchTerm, uploadAndImportUsers, uploadImportUsersFailure, updateCSVToUpload, updateThumbnailToUpload, updateUsers } from '../store/users/actions';

import Card from 'components/Card';
import Content from 'components/Content';
import ContentHeader from 'components/ContentHeader';
import ContentOptions from 'components/ContentOptions';
import ContentOptionsMenu from 'components/ContentOptionsMenu';
import LoadingSpinner from 'components/LoadingSpinner';
import ModalConfirm from 'components/ModalConfirm';
import Search from 'components/Search';
import UserDetailsModal from './../modals/UserDetailsModal';
import UserEditModal from './../modals/UserEditModal';
import UserGroupReviewModal from './../modals/UserGroupReviewModal';
import UserGroupSelectionModal from './../modals/UserGroupSelectionModal';
import UserImportModal from './../modals/UserImportModal';

import { FILTER_BY_OPTIONS, SORT_BY_OPTIONS } from './constants';
import { MODALS } from 'utils/constants';

class UsersIndividualsPage extends React.Component {
    constructor() {
        super();

        this.oldGroup = {};
        this.oldUser = {};

        this.state = {
            showImportCloseButton: false
        };
    }

    componentWillMount() {
        this.props.emptyUsers();
    }

    _loadUsers() {
        if(this.props.users.isFetching === false) {
            this.props.getUsers();
        }
    }

    _closeUserEditModal() {
        if(this.props.users.user.id != null) {
            this.props.setUser(this.oldUser);
            this.props.openModal(MODALS.USER_DETAILS);
        } else {
            this.props.clearUser();
            this.props.closeModal();
            this.oldUser = {};
        }
        this.props.updateThumbnailToUpload(null);
    }

    createAssignmentFromUser(user) {
        let newAssignmentObj = update(emptyAssignment, {
            users: { $push: [user] }
        });

        this.props.setAssignment(newAssignmentObj);
        this.props.changeLocation('/assignments/new');
    }

    /**
     * @desc    Handles the click on a user and opens the user details modal
     * @param   user (obj)
     */
    _openUserModal(user, modal) {
        if(user != null) {
            this.props.getAssignmentsAndSetUser(user);
        }
        this.oldUser = JSON.parse(JSON.stringify(user));
        this.props.openModal(modal);
    }

    _confirmDelete(user) {
        this.props.setUser(user);
        this.props.openConfirmModal(MODALS.USER_DELETE_CONFIRM);
    }

    _cancelDelete() {
        this.props.closeConfirmModal();
        if(this.props.app.modal === '') {
            this.props.clearUser();
        }

    }

    /**
     * @desc    Tests for a search term, and dispatches either search action or getSortedUsers action
     * @param   searchTerm (string)
     */
    _handleSearch() {
        let newUsersObj = update(this.props.users, {
            pageNumber: {$set: 0},
            hasMore: {$set: true},
            allUsers: {$set: []}
        });
        this.props.updateUsers(newUsersObj);
        this.props.getUsers();
    }

    /**
     * @desc    Dispatches actions necessary to sort and GET users
     * @param   sortBy
     * @param   sortDirection
     */
    _handleSort(sortBy, sortDirection) {
        let newUsersObj = update(this.props.users, {
            pageNumber: {$set: 0},
            sortBy: {$set: sortBy},
            sortDirection: {$set: sortDirection},
            searchTerm: {$set: ''},
            hasMore: {$set: true},
            allUsers: {$set: []}
        });
        this.props.updateUsers(newUsersObj);
        this.props.getUsers();
    }

    _handleDeleteUser() {
        this.props.deleteUser(() => {
            this.props.closeConfirmModal();
            this.props.closeModal();
        });
    }


    /**
     * @desc    Dispatches actions necessary to filter and GET users
     * @param   sortBy
     * @param   sortDirection
     */
    _handleFilter(filterBy) {
        let newUsersObj = update(this.props.users, {
            pageNumber: {$set: 0},
            filterBy: {$set: filterBy},
            searchTerm: {$set: ''},
            hasMore: {$set: true},
            allUsers: {$set: []}
        });
        this.props.updateUsers(newUsersObj);
        this.props.getUsers();
    }

    openGroupReviewModal() {
        if(this.props.users.user.department != null) {
            this.oldGroup = JSON.parse(JSON.stringify(this.props.users.user.department));
        }
        this.props.openModal(MODALS.USER_GROUP_REVIEW);
    }

    openGroupSelectionModal() {
        this.props.openModal(MODALS.USER_GROUP_SELECTION);
    }

    _loadMoreGroups() {
        if(this.props.groups.isFetching === false) {
            this.props.getGroups();
        }
    }

    _handleSaveUser() {
        let itemExists = this.props.users.user.id != null;
        if(this.props.users.thumbnailToUpload != null) {
            this.props.postUserAvatar(() => {
                if(itemExists === true) {
                    this.props.openModal(MODALS.USER_DETAILS);
                } else {
                    this.props.clearUser();
                    this.props.closeModal();
                    this.props.updateThumbnailToUpload(null);
                }
            });
        } else {
            this.props.postPutUser(() => {
                if(itemExists === true) {
                    this.props.openModal(MODALS.USER_DETAILS);
                } else {
                    this.props.clearUser();
                    this.props.closeModal();
                }
            });
        }
    }

    _handleThumbnailSelectedToUpload(file) {
        this.props.updateThumbnailToUpload(file);
    }

    _handleCSVSelectedToUpload(file, badFile) {
        let fileArr = file[0].name.split('.');

        if(fileArr[fileArr.length - 1] === 'csv') {
            this.props.uploadAndImportUsers(file[0], (res) => {
                if(res === 'Success') {
                    this.setState({showImportCloseButton: true});
                }
            });
        } else {
            this.props.uploadImportUsersFailure({friendlyMessage: 'No valid file selected. Please try again.'});
        }
    }

    _closeGroupReviewModal(shouldResetGroup) {
        if(shouldResetGroup === true && this.oldGroup != null) {
            let newUserObj = update(this.props.users.user, {
                department: {$set: JSON.parse(JSON.stringify(this.oldGroup))}
            });
            this.props.setUser(newUserObj);
        }
        this.props.openModal(MODALS.USER_EDIT);
    }

    _handleGroupSelection(group) {
        let newUserObj = update(this.props.users.user, {
            department: {$set: group}
        });
        this.props.setUser(newUserObj);
    }

    render() {
        let { clearUser, closeConfirmModal, closeModal, emptyGroups, openModal, setUser, updateThumbnailToUpload, users } = this.props;
        let { allUsers, filterBy, isSaving, searchTerm, sortBy, sortDirection, csvToUpload, thumbnailToUpload, user } = users;

        return (
            <Content className="has-tabs">
                <ContentHeader>
                    <Search handleSearchTermChange={this.props.updateSearchTerm}
                            handleSearch={this._handleSearch.bind(this)}
                            value={users.searchTerm} />
                    <ContentOptions>
                        <ContentOptionsMenu icon="sort"
                                            disabled={searchTerm !== ''}>
                            {SORT_BY_OPTIONS.map((option) => {
                                return (
                                    <div role="button"
                                         className={classNames({'active': searchTerm === '' && option.sortBy === sortBy && option.sortDirection === sortDirection})}
                                         onClick={this._handleSort.bind(this, option.sortBy, option.sortDirection)}
                                         key={option.key}>
                                        {option.text}
                                    </div>
                                )
                            })}
                        </ContentOptionsMenu>
                        <ContentOptionsMenu icon="filter"
                                            disabled={searchTerm !== ''}>
                            {FILTER_BY_OPTIONS.map((option) => {
                                if(option.rolesThatHaveAccess == null || option.rolesThatHaveAccess.indexOf(this.props.auth.role) !== -1) {
                                    return (
                                        <div role="button"
                                             className={classNames({'active': searchTerm === '' && option.filterBy === filterBy})}
                                             onClick={this._handleFilter.bind(this, option.filterBy)}
                                             key={option.key}>
                                            {option.text}
                                        </div>
                                    )
                                } else {
                                    return null;
                                }
                            })}
                        </ContentOptionsMenu>
                    </ContentOptions>
                </ContentHeader>

                <ReduxInfiniteScroll elementIsScrollable={false}
                                     hasMore={users.hasMore}
                                     loadMore={this._loadUsers.bind(this)}
                                     loadingMore={users.isFetching === true}
                                     className="cards"
                                     loader={<LoadingSpinner />}>
                    {allUsers.map((user, index) => {
                        return <Card createAssignment={this.createAssignmentFromUser.bind(this, user)}
                                     item={user}
                                     key={user.id}
                                     handleDelete={this._confirmDelete.bind(this, user)}
                                     onClick={this._openUserModal.bind(this, user, MODALS.USER_DETAILS)}
                                     openEditModal={this._openUserModal.bind(this, user, MODALS.USER_EDIT)}
                        />;
                    })}
                    <div className="card empty"></div>
                    <div className="card empty"></div>
                    <div className="card empty"></div>
                    {users.hasMore === false ? (
                        <div className="cards__no-more">
                            No more individuals to load.
                        </div>
                    ) : null}
                </ReduxInfiniteScroll>

                <UserDetailsModal closeModal={() => {
                                      closeModal();
                                      clearUser();
                                      updateThumbnailToUpload(null);
                                  }}
                                  deleteUser={this._confirmDelete.bind(this)}
                                  isFetchingAssignments={users.isFetching || users.isFetchingAssignments}
                                  isSaving={isSaving}
                                  openModal={openModal.bind(this)}
                                  user={user}
                                  show={this.props.app.modal === MODALS.USER_DETAILS}
                                  />

                <UserEditModal closeModal={() => {
                                   closeModal();
                                   clearUser();
                                   updateThumbnailToUpload(null);
                               }}
                               cancelModal={this._closeUserEditModal.bind(this)}
                               handleGroupListEditClick={this.openGroupReviewModal.bind(this)}
                               handleThumbnailSelectedToUpload={this._handleThumbnailSelectedToUpload.bind(this)}
                               isSaving={isSaving}
                               saveError={users.saveError}
                               saveUser={this._handleSaveUser.bind(this)}
                               setUser={setUser.bind(this)}
                               show={this.props.app.modal === MODALS.USER_EDIT}
                               thumbnailToUpload={thumbnailToUpload}
                               user={user} />


                <UserGroupReviewModal closeModal={() => {
                                      closeModal();
                                      clearUser();
                                      emptyGroups();
                                  }}
                                  openSelectionModal={this.openGroupSelectionModal.bind(this)}
                                  removeGroup={this.props.openConfirmModal.bind(this, MODALS.USER_GROUP_REMOVE_CONFIRM)}
                                  reviewConfirm={this._closeGroupReviewModal.bind(this, false)}
                                  reviewCancel={this._closeGroupReviewModal.bind(this, true)}
                                  show={this.props.app.modal === MODALS.USER_GROUP_REVIEW}
                                  user={user} />

                <UserGroupSelectionModal closeModal={() => {
                                             closeModal();
                                             clearUser();
                                             emptyGroups();
                                         }}
                                         groups={this.props.groups}
                                         loadMore={this._loadMoreGroups.bind(this)}
                                         handleChange={this._handleGroupSelection.bind(this)}
                                         openReviewModal={() => {
                                             openModal(MODALS.USER_GROUP_REVIEW);
                                             emptyGroups();
                                         }}
                                         show={this.props.app.modal === MODALS.USER_GROUP_SELECTION}
                                         user={user} />

                <UserImportModal closeModal={() => {
                                     closeModal();
                                     this.props.updateCSVToUpload(null);
                                     this.setState({showImportCloseButton: false});
                                 }}
                                 error={users.uploadError}
                                 handleFileSelectedToUpload={this._handleCSVSelectedToUpload.bind(this)}
                                 fileToUpload={csvToUpload}
                                 show={this.props.app.modal === MODALS.USER_IMPORT}
                                 showCloseButton={this.state.showImportCloseButton} />

                {/*Modal for confirming delete user*/}
                <ModalConfirm show={this.props.app.modalConfirm === MODALS.USER_DELETE_CONFIRM}
                              cancelAction={this._cancelDelete.bind(this)}
                              confirmAction={this._handleDeleteUser.bind(this)}
                              confirmText="Remove"
                              disabled={isSaving}
                              text="This action will permanently remove your user from the list. If the user is currently in use it will remain attached to its assignment(s)."
                              title="Remove?" />

                {/*Modal for confirming removal of group from user*/}
                <ModalConfirm show={this.props.app.modalConfirm === MODALS.USER_GROUP_REMOVE_CONFIRM}
                              cancelAction={closeConfirmModal.bind(this)}
                              confirmAction={() => {
                                  this._handleGroupSelection({});
                                  this.props.closeConfirmModal();
                              }}
                              disabled={isSaving}
                              text={`Are you sure you want to remove this group?`} />
            </Content>
        )
    }
}

const mapStateToProps = (state) => {
    return {
        app: state.app,
        auth: state.auth,
        groups: state.groups,
        users: state.users
    }
};

const mapDispatchToProps = (dispatch) => {
    return {
        changeLocation: (locationString) => dispatch(routerActions.push(locationString)),
        clearUser: () => dispatch(clearUser()),
        deleteUser: (callback) => dispatch(deleteUser(callback)),
        emptyGroups: () => dispatch(emptyGroups()),
        emptyUsers: () => dispatch(emptyUsers()),
        getAssignmentsAndSetUser: (user) => dispatch(getAssignmentsAndSetUser(user)),
        getGroups: (callback) => dispatch(getGroups(callback)),
        getUsers: (callback) => dispatch(getUsers(callback)),
        postPutUser: (callback) => dispatch(postPutUser(callback)),
        postUserAvatar: (callback) => dispatch(postUserAvatar(callback)),
        closeConfirmModal: () => dispatch(closeConfirmModal()),
        closeModal: () => dispatch(closeModal()),
        openConfirmModal: (modalNameString) => dispatch(openConfirmModal(modalNameString)),
        openModal: (modalNameString) => dispatch(openModal(modalNameString)),
        setAssignment: (assignmentObj) => dispatch(setAssignment(assignmentObj)),
        setUser: (userObj) => dispatch(setUser(userObj)),
        updateSearchTerm: (searchTerm) => dispatch(updateSearchTerm(searchTerm)),
        updateCSVToUpload: (file) => dispatch(updateCSVToUpload(file)),
        updateThumbnailToUpload: (file) => dispatch(updateThumbnailToUpload(file)),
        updateUsers: (usersObj) => dispatch(updateUsers(usersObj)),
        uploadAndImportUsers: (file, callback) => dispatch(uploadAndImportUsers(file, callback)),
        uploadImportUsersFailure: (errorObj) => dispatch(uploadImportUsersFailure(errorObj))
    }
};

export default connect(mapStateToProps, mapDispatchToProps)(UsersIndividualsPage);



// WEBPACK FOOTER //
// ./src/containers/UsersPage/UsersIndividualsPage/index.js